import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'
import { useGqlMikro } from '~/composables/useGqlMikro'
import type { CollectGraphql } from '~/types/graphql-backend-types/gql-types'

export const COLLECTS_WITH_MISSING_FIELDS_QUERY_KEY = () => ['collects-with-missing-fields']

export function useCollectsWithMissingFields() {
  const { query } = useGqlMikro()

  return useQuery({
    queryKey: COLLECTS_WITH_MISSING_FIELDS_QUERY_KEY(),
    queryFn: async () => {
      const { data, errors } = await query({
        query: COLLECTS_WITH_MISSING_FIELDS,
        variables: { pagination: { limit: 100, offset: 0 } },
      })

      if (errors && errors.length > 0) {
        throw errors
      }

      return data.collectsWithMissingFields as CollectGraphql[]
    },
    select(data) {
      return JSON.parse(JSON.stringify(data))
    },
  })
}

const COLLECTS_WITH_MISSING_FIELDS = gql`
query CollectsWithMissingFields {
  collectsWithMissingFields {
    licensePlate
    createdAt
    id
    startsAt
    endsAt
    status
    missingInformations
    collectedContainers {
      collection {
        quantity
        unit
        id
        treatmentCode
        missingInformations
        documents {
          collection {
            id
            signedUrl
          }
        }
        material {
          id
          name
        }
        container {
          id
          name
          material {
            id
            name
          }
        }
      }
    }
    client { 
      id
      name
    }
  }
}
`
